import { useIsRestoring, useMutation, useQueries, useQuery, useQueryClient } from "@tanstack/react-query";
import api from "../api";

export const useGetEmployees = (params, queryparams={}) => {

    return useQuery({
        queryKey: ["employees", params],
        queryFn: async () => (await api.get("/employees_admin/", { ...params })).data,
        ...queryparams
    });
}